import React, { useState, useEffect, Fragment } from 'react'
import { Card, CardBody, Row, Col, FormGroup, Label, Alert, Nav, NavItem, NavLink, Button } from 'reactstrap'
import { getInstructorData, getInstructorwithStudentData, getInstructorDataWithClass } from '../../lib/taskmanageview'
import { getDataforInstructorActiveStudent } from '../../lib/classdetailview'
import { getInstructorIdData } from '../../lib/classview'
import { updateData, deleteIdData } from '../../lib/taskm'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { TaskEdit } from './TaskEdit'
import { Breadcrumbs } from '../../AbstractElements'
import HeaderCard from '../Common/Component/HeaderCard'
import InstructorTaskModal from './InstructorTaskModal'

const InstructorTaskList = () => {
	const [tasklist, setTaskList] = useState([])
	const [category, setCategory] = useState('Student')
	const [selectedStudent, setSelectedStudent] = useState('All')
	const [selectedClass, setSelectedClass] = useState('')
	const [collapseOpenClose, setCollapseOpenClose] = useState(false)
	const [instructorStudent, setInstructorStudent] = useState([])
	const [instructorClass, setInstructorClass] = useState([])
	const [tab, setTab] = useState(2) // 1: All, 2: Current, 3: Later, 4: Closed
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(true)
	const [updatedId, setUpdatedId] = useState(null) // eslint-disable-line no-unused-vars
	const [status, setStatus] = useState(false)
	const [isDarkMode, setIsDarkMode] = useState(false)
	const [isModalOpen, setIsModalOpen] = useState(false)

	const { user } = useAuth()

	const handleDelete = async (id) => {
		const choice = window.confirm('Are You Sure?')
		if (choice) {
			try {
				await deleteIdData(id)
				GetFilterData()
			} catch (error) {
				console.error('Error deleting task:', error)
				setError('Failed to delete task')
			}
		}
	}

	const collapseAll = () => {
		setCollapseOpenClose(!collapseOpenClose)
	}

	const GetAllData = async () => {
		try {
			setLoading(true)
			const tasks = await getInstructorData(user.id)
			setFilterData(tasks)
		} catch (error) {
			console.error('Error fetching all tasks:', error)
			setError('Failed to load tasks')
		} finally {
			setLoading(false)
		}
	}

	const setFilterData = (tasks) => {
		setTaskList([])
		if (tab === 1) {
			// All
			setTaskList(tasks)
		} else if (tab === 2) {
			// Current
			setTaskList(tasks.filter((opt) => opt.statusway === 'Current'))
		} else if (tab === 3) {
			// Later
			setTaskList(tasks.filter((opt) => opt.statusway === 'Later'))
		} else if (tab === 4) {
			// Closed
			setTaskList(tasks.filter((opt) => opt.statusway === 'Closed'))
		}
	}

	const GetStudentData = async (studentId) => {
		try {
			setLoading(true)
			const tasks = await getInstructorwithStudentData(user.id, studentId)
			setFilterData(tasks)
		} catch (error) {
			console.error('Error fetching student tasks:', error)
			setError('Failed to load student tasks')
		} finally {
			setLoading(false)
		}
	}

	const GetClassData = async (clas) => {
		try {
			setLoading(true)
			const tasks = await getInstructorDataWithClass(user.id, clas)
			setFilterData(tasks)
		} catch (error) {
			console.error('Error fetching class tasks:', error)
			setError('Failed to load class tasks')
		} finally {
			setLoading(false)
		}
	}

	const GetInstructorStudentData = async () => {
		try {
			const students = await getDataforInstructorActiveStudent(user.id)
			setInstructorStudent(students)
			setSelectedStudent('All') // Set default to "All"

			const clas = await getInstructorIdData(user.id)
			setInstructorClass(clas)
			if (clas.length > 0) {
				setSelectedClass(clas[0].id)
			}
		} catch (error) {
			console.error('Error fetching instructor data:', error)
			setError('Failed to load instructor data')
		}
	}

	const GetFilterData = () => {
		if (category === 'Student') {
			if (selectedStudent !== 'All') GetStudentData(selectedStudent)
			else GetAllData()
		} else {
			if (selectedClass) GetClassData(selectedClass)
		}
	}

	const ChangeTaskStatus = async (Id, statusway) => {
		try {
			await updateData({
				id: Id,
				statusway: statusway
			})
			GetFilterData()
		} catch (error) {
			console.error('Error updating task status:', error)
			setError('Failed to update task status')
		}
	}

	const toggleTab = (id) => {
		setTab(id)
	}

	const toggleModal = () => {
		setIsModalOpen(!isModalOpen)
	}

	const handleAddTask = () => {
		setIsModalOpen(true)
	}

	// Custom header component with category selector and tabs
	const customHeaderComponent = (
		<div>
			<Row className="mb-3">
				{/* Category selector */}
				<Col lg="3">
					<FormGroup>
						<Label className="form-control-label">Category</Label>
						<div className="d-flex gap-3">
							<div className="form-check">
								<input
									className="form-check-input"
									type="radio"
									name="category"
									id="flexRadioDefault1"
									value="Student"
									checked={category === 'Student'}
									onChange={(e) => setCategory('Student')}
								/>
								<label className="form-check-label" htmlFor="flexRadioDefault1">
									Student
								</label>
							</div>
							<div className="form-check">
								<input
									className="form-check-input"
									type="radio"
									name="category"
									id="flexRadioDefault2"
									value="Class"
									checked={category === 'Class'}
									onChange={(e) => setCategory('Class')}
								/>
								<label className="form-check-label" htmlFor="flexRadioDefault2">
									Class
								</label>
							</div>
						</div>
					</FormGroup>
				</Col>
				<Col lg="3">
					<FormGroup>
						<Label className="form-control-label">{category === 'Student' ? 'Students' : 'Class'}</Label>
						<select
							value={category === 'Student' ? selectedStudent : selectedClass}
							onChange={(e) => {
								if (category === 'Student') {
									setSelectedStudent(e.target.value)
								} else {
									setSelectedClass(e.target.value)
								}
							}}
							className="form-control"
							style={{
								backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
								color: isDarkMode ? '#fff' : 'inherit'
							}}
						>
							{category === 'Student' ? (
								<>
									<option value="All">All</option>
									{instructorStudent.map((data, ix) => (
										<option key={ix} value={data.studentId}>
											{data.studentName + ' ' + data.studentSurname}
										</option>
									))}
								</>
							) : (
								instructorClass.map((data, ix) => (
									<option key={ix} value={data.id}>
										{data.class_name}
									</option>
								))
							)}
						</select>
					</FormGroup>
				</Col>
				<Col lg="6" className="text-end">
					<Button onClick={handleAddTask} color="primary">
						<i className="fa fa-plus me-2"></i>
						Add New Item
					</Button>
				</Col>
			</Row>

			<Row className="align-items-center">
				<Col lg="8">
					<Nav tabs>
						<NavItem>
							<NavLink className={tab === 1 ? 'active' : ''} onClick={() => toggleTab(1)} style={{ cursor: 'pointer' }}>
								All
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink className={tab === 2 ? 'active' : ''} onClick={() => toggleTab(2)} style={{ cursor: 'pointer' }}>
								Agenda-1
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink className={tab === 3 ? 'active' : ''} onClick={() => toggleTab(3)} style={{ cursor: 'pointer' }}>
								Agenda-2
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink className={tab === 4 ? 'active' : ''} onClick={() => toggleTab(4)} style={{ cursor: 'pointer' }}>
								Closed
							</NavLink>
						</NavItem>
					</Nav>
				</Col>
				<Col lg="4" className="text-end">
					<button type="button" className="btn btn-outline-info" onClick={() => collapseAll()}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="18"
							height="18"
							fill="currentColor"
							className="bi bi-chevron-double-down"
							viewBox="0 0 16 16"
						>
							<path
								fillRule="evenodd"
								d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
							/>
							<path
								fillRule="evenodd"
								d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
							/>
						</svg>
						<span className="ms-2 fs-6">Collapse All</span>
					</button>
				</Col>
			</Row>
		</div>
	)

	useEffect(() => {
		if (user?.id) {
			GetInstructorStudentData()
		}
	}, [user?.id])

	useEffect(() => {
		if (user?.id) {
			GetFilterData()
		}
	}, [selectedClass, selectedStudent, category, user?.id])

	useEffect(() => {
		if (user?.id) {
			GetFilterData()
		}
	}, [tab, user?.id])

	useEffect(() => {
		const checkDarkMode = () => {
			setIsDarkMode(document.body.classList.contains('dark-only'))
		}
		checkDarkMode()
		const observer = new MutationObserver(checkDarkMode)
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
		return () => observer.disconnect()
	}, [])

	const tableStyle = {
		backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
		color: isDarkMode ? '#fff' : 'inherit'
	}

	const selectStyle = {
		backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
		color: isDarkMode ? '#fff' : 'inherit'
	}

	return (
		<>
			<Breadcrumbs parent="Task Management" title="Class Task" mainTitle="Class Task" />
			<div className="container-fluid">
				<Row>
					<Col sm="12">
						<Card>
							<HeaderCard title="Class Task" subTitle="Manage student and class tasks" />
							<CardBody>
								{error && (
									<Alert color="danger" className="alert-dismissible fade show" role="alert">
										<strong>Error:</strong> {error}
										<button type="button" className="btn-close" onClick={() => setError('')} aria-label="Close"></button>
									</Alert>
								)}

								<div className="mb-3">{customHeaderComponent}</div>

								{loading ? (
									<div className="text-center">
										<div className="spinner-border" role="status">
											<span className="visually-hidden">Loading...</span>
										</div>
										<p className="mt-2">Loading tasks...</p>
									</div>
								) : (
									<div className="table-responsive">
										<table className="table table-nowrap mb-0" style={tableStyle}>
											<thead>
												<tr>
													<th>Topic</th>
													<th>Student</th>
													<th>Date</th>
													<th>Status</th>
													<th>Detail</th>
													<th>Process</th>
												</tr>
											</thead>
											<tbody>
												{tasklist.length > 0 ? (
													tasklist.map((data) => (
														<Fragment key={data.id}>
															<tr>
																<td>{data.subject}</td>
																<td>{data.studentinfo}</td>
																<td>{data.setDate}</td>
																<td>
																	<div className="select-container2 mx-2">
																		<select
																			value={data.statusway || ''}
																			onChange={(e) => ChangeTaskStatus(data.id, e.target.value)}
																			className="form-control"
																			style={selectStyle}
																		>
																			<option value="Current">Agenda-1</option>
																			<option value="Later">Agenda-2</option>
																			<option value="Closed">Closed</option>
																		</select>
																	</div>
																</td>
																<td>
																	<button
																		type="button"
																		className="btn btn-outline-info"
																		onClick={() => {
																			const target = document.getElementById(`collapseExample${data.id}`)
																			if (target) {
																				target.classList.toggle('show')
																			}
																		}}
																	>
																		<svg
																			xmlns="http://www.w3.org/2000/svg"
																			width="16"
																			height="16"
																			fill="currentColor"
																			className="bi bi-chevron-double-down"
																			viewBox="0 0 16 16"
																		>
																			<path
																				fillRule="evenodd"
																				d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
																			/>
																			<path
																				fillRule="evenodd"
																				d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
																			/>
																		</svg>
																	</button>
																</td>
																<td>
																	<Button type="button" className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
																		<i className="fa fa-trash"></i>
																	</Button>
																</td>
															</tr>
															<tr className={`collapse ${collapseOpenClose ? 'show' : ''}`} id={`collapseExample${data.id}`}>
																<td colSpan="6" style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
																	<div className="p-3" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>
																		<TaskEdit value={data.desc} id={data.id} setStatus={setStatus} status={status} setUpdatedId={setUpdatedId} isDarkMode={isDarkMode} />
																	</div>
																</td>
															</tr>
														</Fragment>
													))
												) : (
													<tr>
														<td colSpan="6" className="text-center">
															No tasks found
														</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								)}
							</CardBody>
						</Card>
					</Col>
				</Row>
			</div>
			<InstructorTaskModal
				isOpen={isModalOpen}
				toggle={toggleModal}
				instructorId={user?.id}
				onSave={GetFilterData}
				isDarkMode={isDarkMode}
			/>
		</>
	)
}

export { InstructorTaskList }
